import styled from 'styled-components';

const CellTextWrapper = styled.div`
  white-space: nowrap;
  overflow: hidden;

  &.no-text-transform {
    text-transform: none !important;
  }
`;

const EllipsisTextWrapper = styled.div`
  overflow: hidden;

  max-width: 300px;
  min-width: 150px;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  &.no-text-transform {
    text-transform: none !important;
  }
`;

export const BaseTableEllipsisTextWrapper = EllipsisTextWrapper;
export const BaseTableCellTextWrapper = CellTextWrapper;
